/* eslint-disable @typescript-eslint/naming-convention */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de_DE from "translation/de-DE.json";
import en from "translation/en.json";
import es_ES from "translation/es-ES.json";
import fr_FR from "translation/fr-FR.json";
import it_IT from "translation/it-IT.json";
import ja from "translation/ja.json";
import ko_KR from "translation/ko-KR.json";
import zh_CN from "translation/zh-CN.json";
import zh_TW from "translation/zh-TW.json";

i18n.use(initReactI18next).init({
  resources: {
    "de-DE": {
      translation: de_DE,
    },
    en: {
      translation: en,
    },
    "es-ES": {
      translation: es_ES,
    },
    "fr-FR": {
      translation: fr_FR,
    },
    "it-IT": {
      translation: it_IT,
    },
    ja: {
      translation: ja,
    },
    "ko-KR": {
      translation: ko_KR,
    },
    "zh-CN": {
      translation: zh_CN,
    },
    "zh-TW": {
      translation: zh_TW,
    },
  },
  lng: "en",
  fallbackLng: 'en',
  defaultNS: "translation",
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;
